import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getUserDetails } from '../../../api/auth'

import Cookies from 'js-cookie'

export const fetchUserRoles = createAsyncThunk('user/getUserDetails', async (useCache, { getState }) => {
    if(useCache){
        const existingData = getState().userDetails

        if (existingData?.activeRoleId) {
            return {
                data: {
                    activeRole: existingData.activeRoleId,
                    companyDetails: existingData.companyDetails,
                    pmCompanyDetails: existingData.PMCompanyDetails,
                    userRoleDetails: existingData.rolesList,
                    userId: existingData.userId,

                    permActions: existingData.permActions,
                    permRoles: existingData.permRoles,
                    permGeo: existingData.permGeo,
                    permExceptions: existingData.permExceptions
                }
            }
        }
    }
    
    const response = await getUserDetails()
    console.log("getPMUserDetails", response)
    return response
})

export const userDetailsSlice = createSlice({
    name : "userDetails",
    initialState : {
        jwtToken: Cookies.get('jwtTokenClient'),
        rolesList: [],
        PMCompanyDetails: {},
        companyDetails: {},
        activeRoleId: null,
        activeCompanyRoleId: null,
        activeUserRoleDetails: {},
        loading: true,
        userId: null,
        userNameDetails: [],
        isUserGoogleVerified: false,

        permActions: [],
        permRoles: [],
        permGeo: [],
        permExceptions: []
    },
    reducers: {
        removeToken: (state, action) => {
            console.log('this is triggered')
            state.jwtToken = Cookies.get('jwtTokenClient')
        },
        setToken: (state, action) => {
            state.jwtToken = Cookies.get('jwtTokenClient')
        },
        updateUserGoogleVerification: (state, action) => {
            console.log('action', action.payload)
            state.isUserGoogleVerified = action.payload
        },
        setLoading: (state, action) => {
            state.loading = false
        }
    },
    extraReducers : (builder) => {

        builder.addCase(
            fetchUserRoles.fulfilled, (state, action) => {
                const rolesData = action.payload.data.userRoleDetails
                const companyDetails = action.payload.data.companyDetails
                const pmCompanyDetails = action.payload.data.pmCompanyDetails
                const activeRole = action.payload.data.activeRole
                const userId = action.payload.data.userId
                const userNameDetails = action.payload.data.userNameDetails
                const isUserGoogleVerified = action.payload.data.userNameDetails?.googleRefreshToken ? true : false

                const activeUserRoleDetails = rolesData?.find(eachRole => eachRole.userRoleId === activeRole)

                const permActions = action.payload.data.permActions
                const permExceptions = action.payload.data.permExceptions
                const permGeo = action.payload.data.permGeo
                const permRoles = action.payload.data.permRoles

                state.rolesList = rolesData
                state.companyDetails = companyDetails
                state.PMCompanyDetails = pmCompanyDetails
                state.activeRoleId = activeRole
                state.activeUserRoleDetails = activeUserRoleDetails
                state.activeCompanyRoleId = activeUserRoleDetails?.companyRoleId
                state.loading = false 
                state.userId = userId
                state.userNameDetails = userNameDetails
                state.isUserGoogleVerified = isUserGoogleVerified

                state.permActions = permActions
                state.permExceptions = permExceptions
                state.permGeo = permGeo
                state.permRoles = permRoles
            }
        )
        .addCase(
            fetchUserRoles.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchUserRoles.rejected, (state, action) => {
                state.loading = false
            }
        )
        

    }
})

export const { removeToken, setToken, setLoading, updateUserGoogleVerification } = userDetailsSlice.actions

export default userDetailsSlice.reducer